import React, { useState } from 'react';
import Helmet from 'react-helmet';
import { Inertia } from '@inertiajs/inertia';
import { InertiaLink, usePage } from '@inertiajs/inertia-react';
import UserLayout from '../../../Shared/UserLayout';
import TextInput from '../../../Shared/TextInput';
import FileInput from '../../../Shared/FileInput';
import SelectInput from '../../../Shared/SelectInput';
import LoadingButton from '../../../Shared/LoadingButton';
import ProfileCard from '../../../Shared/ProfileCard';
import DataCard from '../../../Shared/DataCard';
import { toFormData } from '../../../utils';

const Create = () => {
     const { auth, errors, data } = usePage().props;
     const [sending, setSending] = useState(false);
     const [values, setValues] = useState({
          first_name: '',
          last_name: '',
          sex: '',
          password: '',
          password_confirmation:'',
          avatar: null,
          path: null,
          errors: errors
     });

     function handleChange(e) {
          const key = e.target.name;
          const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
          setValues(values => ({
               ...values,
               [key]: value
          }));
     }

     function handleFileChange(file, path) {
          setValues(values => ({
               ...values,
               photo: file,
               path: path
          }));
     }

     function handleSubmit(e) {
          e.preventDefault();
          setSending(true);
          const formData = toFormData(values, 'POST');
          Inertia.post(route('student.store'), formData).then(() => {
               setSending(false);
          });
     }

     return (
          <React.Fragment key="uprofile">
               <Helmet>
                    <title>Student Profile</title>
               </Helmet>
               <form onSubmit={handleSubmit}>
                    <ProfileCard>
                         <div className="md:col-span-1">
                              <div className="px-4 sm:px-0">
                                   <h3 className="text-lg font-medium text-gray-900">Student Information</h3>
                                   <p className="mt-1 text-sm text-gray-600">
                                        Add information for the kid you want to manage account directly only. Remember that after creating the student, that doesn't give him/her full access tou our resources.
                                   </p>
                                   <p className="mt-1 text-sm text-gray-600">
                                        You don't need to create a username or add an e-mail since the system will be generating an easy to remember one for you.
                                   </p>
                                   <div className="w-full mt-3">
                                        <h3 className="text-md text-gray-700 text-center">Current Photo</h3>
                                        {!values.avatar && (<img src={`https://ui-avatars.com/api/?name=${auth.user.name}&amp;color=7F9CF5&amp;background=EBF4FF`} className="mx-auto rounded-full h-20 w-20" />)}
                                        {values.avatar && (<img src={`${auth.user.avatar}`} className="mx-auto rounded-full h-20 w-20" />)}
                                   </div>
                              </div>
                         </div>
                         <DataCard>
                              <div className="px-4 py-5 sm:p-6">
                                   <div className="grid grid-cols-6 gap-6">
                                        <div className="col-span-6 sm:col-span-4">
                                             <label className="block font-medium text-sm text-gray-700" htmlFor="photo">
                                                  <span>Photo</span>
                                             </label>
                                             <div className="mt-2">
                                                  {values.path && (<img src={`${values.path}`} className="rounded-full h-20 w-20" />)}
                                             </div>
                                             <FileInput
                                                  className="w-full lg:w-1/2"
                                                  label="Select Picture"
                                                  name="photo"
                                                  accept="image/jpg,jpeg,png"
                                                  errors={errors.photo}
                                                  value={values.photo}
                                                  onChange={handleFileChange}
                                              />
                                              <TextInput
                                                   className="form-input rounded-md shadow-sm mt-4 block w-full"
                                                   label="First Name"
                                                   name="first_name"
                                                   type="text"
                                                   disable={false}
                                                   readonly={false}
                                                   errors={errors.first_name}
                                                   value={values.first_name}
                                                   onChange={handleChange}
                                              />
                                              <TextInput
                                                   className="form-input rounded-md shadow-sm mt-4 block w-full"
                                                   label="Last Name"
                                                   name="last_name"
                                                   type="text"
                                                   disable={false}
                                                   readonly={false}
                                                   errors={errors.last_name}
                                                   value={values.last_name}
                                                   onChange={handleChange}
                                              />
                                              <SelectInput
                                                  className="block mt-4 appearance-none w-full text-gray-700 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                                  label="Sex"
                                                  name="sex"
                                                  errors={errors.sex}
                                                  value={values.sex}
                                                  onChange={handleChange}
                                              >
                                                  <option value=""></option>
                                                  {data.map(({id, name}) => {
                                                       return <option key={id} value={id}>{name}</option>
                                                  })}
                                              </SelectInput>
                                        </div>
                                   </div>
                              </div>
                         </DataCard>
                    </ProfileCard>
                    <div className="hidden sm:block">
                         <div className="py-8">
                              <div className="border-t border-gray-400"></div>
                         </div>
                    </div>
                    <ProfileCard>
                         <div className="md:col-span-1">
                              <div className="px-4 sm:px-0">
                                   <h3 className="text-lg font-medium text-gray-900">Add Password</h3>
                                   <p className="mt-1 text-sm text-gray-600">
                                        Ensure your account is using a long, random password to stay secure.
                                   </p>
                              </div>
                         </div>

                         <DataCard>
                              <div className="px-4 py-5 sm:p-6">
                                   <div className="grid grid-cols-6 gap-6">
                                        <div className="col-span-6 sm:col-span-4">
                                             <TextInput
                                                  className="form-input rounded-md shadow-sm mt-4 block w-full"
                                                  label="Password"
                                                  name="password"
                                                  type="password"
                                                  disable={false}
                                                  readonly={false}
                                                  errors={errors.password}
                                                  value={values.password}
                                                  onChange={handleChange}
                                             />
                                             <TextInput
                                                  className="form-input rounded-md shadow-sm mt-4 block w-full"
                                                  label="Confirm Password"
                                                  name="password_confirmation"
                                                  type="password"
                                                  disable={false}
                                                  readonly={false}
                                                  errors={errors.password_confirmation}
                                                  value={values.password_confirmation}
                                                  onChange={handleChange}
                                             />
                                        </div>
                                   </div>
                              </div>
                              <div className="flex items-center justify-end px-4 py-3 bg-gray-100 text-right sm:px-6 rounded-b">
                                   <LoadingButton type="submit" loading={sending} className="inline-flex items-center px-4 py-2 bg-gray-800 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest hover:bg-gray-700 active:bg-gray-900 focus:outline-none focus:border-gray-900 focus:shadow-outline-gray disabled:opacity-25 transition ease-in-out duration-150 ml-4">
                                        Create Student Profile
                                   </LoadingButton>
                              </div>
                         </DataCard>
                    </ProfileCard>
               </form>
          </React.Fragment>
     );
};

// Persisten layout
// Docs: https://inertiajs.com/pages#persistent-layouts
Create.layout = page => <UserLayout children={page} header={'Student Profile'} />;

export default Create;
